// NavMenu: the hamburger menu of both navigation bars (bottom NavigationBar on compact screens, top Navbar when its links do not fit).
// A section that has sub-pages is an accordion group: the row toggles it, and inside are the section's own page followed by its sub-pages.
// Props: items=[{ id, label, icon, children? }], value (current page id), onSelect(id), plus Menu props (anchorEl, open, onClose, placement props).
(function () {
  const { Box, Typography } = MaterialUI;
  const { useState, useEffect } = React;

  function NavMenu({ items = [], value, onSelect, ...menuProps }) {
    const { Menu, MenuItem, GoogleIcon } = window.Components;
    const [expanded, setExpanded] = useState(() => new Set());
    const holds = (it, id) => (it.children || []).some(c => c.id === id);
    // Opening the menu expands the group that holds the current page
    useEffect(() => {
      if (menuProps.open) setExpanded(prev => { const n = new Set(prev); items.forEach(i => { if (holds(i, value)) n.add(i.id); }); return n; });
    }, [menuProps.open]);
    const toggle = id => setExpanded(prev => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n; });
    const motion = 'var(--m3-duration-short) var(--m3-easing-standard)';
    const pick = id => { menuProps.onClose && menuProps.onClose(); onSelect && onSelect(id); };

    const rows = items.flatMap(it => {
      if (!(it.children && it.children.length)) {
        return [<MenuItem key={it.id} selected={it.id === value} headline={it.label} leadingIcon={<GoogleIcon name={it.icon} size={20} />} onClick={() => pick(it.id)} />];
      }
      const open = expanded.has(it.id);
      const inside = it.id === value || holds(it, value);
      return [
        <MenuItem key={it.id} aria-expanded={open} onClick={() => toggle(it.id)} leadingIcon={<GoogleIcon name={it.icon} size={20} filled={inside} />}>
          <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, minWidth: 0 }}>
            <Typography component="span" sx={{ flex: 1, minWidth: 0, fontFamily: "var(--wb-font-nav, 'Google Sans', sans-serif)", fontSynthesis: 'none', fontSize: '0.88rem', fontWeight: inside ? 600 : 500, letterSpacing: '0.1px' }}>{it.label}</Typography>
            <GoogleIcon name="expand_more" size={22} style={{ transform: open ? 'rotate(180deg)' : 'none', transition: `transform ${motion}` }} />
          </Box>
        </MenuItem>,
        ...(open ? [it, ...it.children].map((c, n) => (
          <MenuItem key={`${it.id}/${c.id}`} selected={c.id === value} headline={c.label} supportingText={n === 0 ? 'Main page' : undefined}
            leadingIcon={<GoogleIcon name={c.icon} size={20} />} sx={{ ml: 3 }} onClick={() => pick(c.id)} />
        )) : [])
      ];
    });

    return <Menu {...menuProps}>{rows}</Menu>;
  }

  window.Components = window.Components || {};
  window.Components.NavMenu = NavMenu;
})();
